//类型
function toType(obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filter_null(o) {
    for (var key in o) {
        if (o[key] == null) {
            delete o[key]
        }
        if (toType(o[key]) == 'string') {
            o[key] = o[key].trim()
            if (o[key].length == 0) {
                delete o[key]
            }
        }
    }
    return o
}
//接口处理函数
function api_request(method, url, params, success, failure) {
    
    params = filter_null(params);

    if (method === 'POST' || method === 'PUT' || method === 'DELETE')
    {
        params._token = Token;
        params = JSON.stringify(params);
    }
    else if (method === 'GET')
    {
        var queryString = Object.keys(params).map(function(key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
        }).join('&');
        url += (url.includes('?') ? '&' : '?') + queryString;
        params = null;
    }

    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.send(params);
    xhr.onreadystatechange = function() {
        if (xhr.readyState == 4 && (xhr.status >= 200 && xhr.status < 300) ) {
            var response = xhr.responseText;
            success(JSON.parse(response));
        }else{

        }
    };
};

export default {
    get: function(url, params, success, failure) {
        return api_request('GET', url, params, success, failure)
    },
    post: function(url, params, success, failure) {
        return api_request('POST', url, params, success, failure)
    },
    put: function(url, params, success, failure) {
        return api_request('PUT', url, params, success, failure)
    },
    delete: function(url, params, success, failure) {
        return api_request('DELETE', url, params, success, failure)
    },
    //获取URL参数
    getQueryString: function(name)
    { 
        const url = window.location.href;
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
}